import { COMMAND_TYPES } from "../../constants/common";
import { DOCUMENT_COMPONENT_TYPES } from "../../constants/document";
import AddComponentBaseFactory from "./addComponentCommandBase/addComponentBaseFactory";
import DeleteComponentBaseFactory from "./deleteComponentCommandBase/deleteComponentBaseFactory";
import DummyCommand from "./dummyCommand";
import AddHTMLFactory from "./htmlcomponentcommands/addHTMLFactory";
import AddQuoteTableFactory from "./quotetablecommands/addQuoteTableFactory";
import AddSignatureFactory from "./signaturecommands/addSignatureFactory";
import DeleteSignatureFactory from "./signaturecommands/deleteSignatureFactory";
import AddTableFactory from "./tablecomponentcommands/addTableFactory";

class SubCommandFactory {
  static getSubCommandInstance(
    commandType,
    componentType,
    mode,
    isPDF,
    componentData,
  ) {
    if (commandType === COMMAND_TYPES.ADD_COMPONENT) {
      switch (componentType) {
        case DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER:
          return AddSignatureFactory.getCommand(mode, isPDF, componentData);
        case DOCUMENT_COMPONENT_TYPES.HTML:
          return AddHTMLFactory.getCommand(mode, componentData);
        case DOCUMENT_COMPONENT_TYPES.TABLE:
          return AddTableFactory.getCommand(mode, componentData);
        case DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER:
          return AddQuoteTableFactory.getCommand(mode, componentData);
        default:
          return AddComponentBaseFactory.getAddComponentCommandInstance(
            mode,
            isPDF,
            componentData,
          );
      }
    }
    if (commandType === COMMAND_TYPES.DELETE_COMPONENT) {
      switch (componentType) {
        case DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER:
          return DeleteSignatureFactory.getCommand(mode, isPDF, componentData);

        default:
          return DeleteComponentBaseFactory.getDeleteComponentCommandInstance(
            mode,
            isPDF,
            componentData,
          );
      }
    }
    return new DummyCommand();
  }
}

export default SubCommandFactory;
